<template>
  <section>
    <h4 class="text-center mb-5 mt-px">{{ title }}</h4>
    <iframe
      :src="`https://view.officeapps.live.com/op/embed.aspx?src=${src}`"
      width="100%"
      height="900px"
      controls
    >
    </iframe>
  </section>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "DOCX",
    },
    src: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
.docx {
  font-family: Arial, sans-serif;
}
</style>
